import { KeyValuePair } from '@app/core/models/keyValuePair';

class TurnDirections {
  TurningInside = { key: 1, value: 'Binnendraaiend' };
  TurningOutside = { key: 2, value: 'Buitendraaiend' };
  Both = { key: 3, value: 'Beide' };
}
const turnDirections = new TurnDirections();
const keyValuePairs: KeyValuePair[] = [
  turnDirections.TurningInside,
  turnDirections.TurningOutside,
  turnDirections.Both,
];

export {
    turnDirections,
    keyValuePairs
}
